import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((_theme: Theme) => ({
  closeIcon: {
    position: 'fixed',
    top: 10,
    right: 10,
    zIndex: 12002,
  },
  nextIcon: {
    position: 'fixed',
    top: '50%',
    right: 10,
    zIndex: 12002,
  },
  prevIcon: {
    position: 'fixed',
    top: '50%',
    left: 10,
    zIndex: 12002,
  },
}));
